import React from "react";
import Extension from "@contentstack/app-sdk/dist/src/uiLocation";
import { AppRegion, KeyValueObj } from "../../shared-components/common/types/types";

export type MarketplaceAppContextType = {
  appSdk: Extension | null;
  appConfig: KeyValueObj | null;
  appRegion: AppRegion | undefined;
};

export const MarketplaceAppContext = React.createContext<MarketplaceAppContextType>({
  appSdk: null,
  appConfig: null,
  appRegion: undefined,
});
